import React from "react";
import './footerstyle.css';
export default function footer()
{
    return(
        <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="footer-col">
              <h4>company</h4>
              <ul>
                <li><a href="#">about us</a></li>
                <li><a href="#">our services</a></li>
                <li><a href="#">privacy policy</a></li>
                <li><a href="#">affiliate program</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>get help</h4>
              <ul>
                <li><a href="#">FAQ</a></li>
                <li><a href="#">Franchise details</a></li>
                <li><a href="#">Feedback</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Contact Details</h4>
              <ul>
                <li>teatalkpoint@gmail.com</li>
                <li>teatalkpoint@outlook.in</li>
                <li>+911234567890</li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>follow us</h4>
              <ul className="social-links">
          <li className="social"><a href="#"><img src="./facebook.png" /></a></li>
          <li className="social"><a href="#"><img src="./twitter.png" /></a></li>
          <li className="social"><a href="#"><img src="./instagram.png" /></a></li>
        </ul>
            </div>
          </div>
          <div className="copyright"><h4>Copyright &#169; 2024 Harsh Trivedi</h4></div>  
        </div>
        
      </footer>


    );
}